import createClient, { type Middleware } from 'openapi-fetch';
import type { CoreApi, CoreApiSchemas } from '@hive/contracts';
import { session } from '../auth/session';

type S = CoreApiSchemas;
export type NetworkOverview = S['NetworkOverview'];
export type NetworkVenue = S['NetworkVenue'];
export type NetworkVenueDetail = S['NetworkVenueDetail'];
export type NetworkScreenDetail = S['NetworkScreenDetail'];
export type ScreenTelemetry = S['ScreenTelemetry'];
export type Alert = S['Alert'];
export type Measure = S['Measure'];
export type User = S['User'];
export type Permission = S['Permission'];
export type Role = S['Role'];
export type RoleInfo = S['RoleInfo'];
export type UserAccount = S['UserAccount'];
export type AuditEvent = S['AuditEvent'];
export type Venue = S['Venue'];
export type VenueAdminItem = S['VenueAdminItem'];
export type VenueSetup = S['VenueSetup'];
export type ScreenSetup = S['ScreenSetup'];
export type EntitlementDetails = S['EntitlementDetails'];
export type RightsCatalogue = S['RightsCatalogue'];
export type VenueImportResult = S['VenueImportResult'];
export type ApiKey = S['ApiKey'];
export type ApiScope = S['ApiScope'];
export type IntegrationRequest = S['IntegrationRequest'];
export type Webhook = S['Webhook'];
export type WebhookDelivery = S['WebhookDelivery'];
export type EventType = S['EventType'];
export type EventTypeInfo = S['EventTypeInfo'];
export type CrmSource = S['CrmSource'];
export type CrmSyncResult = S['CrmSyncResult'];
export type StreamSetup = S['StreamSetup'];
export type StreamProbe = S['StreamProbe'];

export const baseUrl = import.meta.env.VITE_API_BASE_URL as string | undefined;
export const keeperUrl = (import.meta.env.VITE_KEEPER_URL as string | undefined) ?? '';
if (!baseUrl) throw new Error('VITE_API_BASE_URL is not set. Add it to clients/master-control/.env.development.');

const auth: Middleware = {
  onRequest({ request }) {
    const token = session.token();
    if (token) request.headers.set('Authorization', `Bearer ${token}`);
    return request;
  },
  onResponse({ response }) {
    if (response.status === 401 && session.token()) session.clear();
    return response;
  },
};

/** Typed client generated from packages/contracts/core-api.yaml. */
export const api = createClient<CoreApi.paths>({ baseUrl });
api.use(auth);

export function errorMessage(error: unknown, fallback = 'Something went wrong. Try again.'): string {
  if (error && typeof error === 'object' && 'message' in error) {
    const m = (error as { message: unknown }).message;
    if (typeof m === 'string') return m;
    if (Array.isArray(m) && m.length) return String(m[0]);
  }
  return fallback;
}

/** Latest preview JPEG for a screen as an object URL (img tags cannot send auth headers). */
export async function fetchPreview(screenId: string): Promise<string | null> {
  const token = session.token();
  const res = await fetch(`${baseUrl}/v1/screens/${encodeURIComponent(screenId)}/preview`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) return null;
  return URL.createObjectURL(await res.blob());
}
